// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"132":"b70cc642","354":"3098fbf6","418":"bb4ec7e0"}[chunkId] + ".js";
};